import React, { Fragment } from "react";
import PropTypes from "prop-types";
import LinkItem from "./secondary-link-item";

const SecondaryLinkList = ({ data }) => {
  return (
    <>
      <div className="secondary-link-list">
        <ul className="content" data-cy="Footer secondary links">
          {data &&
            data.map((item, i) => {
              return (
                <Fragment key={`${item?.link}-${item?.text}`}>
                  <li>
                    <LinkItem
                      link={item?.link}
                      text={item?.text}
                      target={item?.target}
                      actionId={item?.actionId}
                    />
                  </li>
                 
                </Fragment>
              );
            })}
        </ul>
      </div>      
    </>
  );
};

export default SecondaryLinkList;

SecondaryLinkList.propTypes = {
  /**
   * {
   *  "info": "Lista de objetos con los campos necesarios para contribuir el listado de links",
   *  "kind": "both",
   *  "beautifulName": "Lista de links"
   * }
   */
  data: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      text: PropTypes.string,
      target: PropTypes.oneOf(["_blank", "_self", "_parent", "_top"]),
    })
  ),
};
